import { ref } from 'vue'
import type { Ref } from 'vue'

export type UseDropdownDirection = {
  buttonRef: Ref<HTMLElement | null>
  dropdownRef: Ref<HTMLElement | null>
  calculateDropdownVerticalPosition: () => void
}

export function useDropdownDirection({ onVerticalChange }: { onVerticalChange: (isWithinWindow: boolean) => void }): UseDropdownDirection {
  const buttonRef = ref<HTMLElement | null>(null)
  const dropdownRef = ref<HTMLElement | null>(null)

  function calculateDropdownVerticalPosition() {
    setTimeout(() => {
      const windowHeight = window.innerHeight
      const buttonElRect = buttonRef.value?.getBoundingClientRect()
      const dropdownRect = dropdownRef.value?.getBoundingClientRect()

      if (!buttonElRect || !buttonRef.value || !dropdownRect) return

      const withinWindow = buttonElRect.y + buttonRef.value.offsetHeight + dropdownRect.height < windowHeight

      onVerticalChange(withinWindow)
    }, 100)
  }

  return {
    buttonRef,
    dropdownRef,
    calculateDropdownVerticalPosition,
  }
}
